import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useRues } from "../hooks/useRues";
import { success, error } from "../utils/alerts";
import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useEffect, useState } from "react";
import axios from "axios";

const opcionesSector = [
  { value: "Privado", label: "Privado" },
  { value: "Público", label: "Público" },
  { value: "Mixto", label: "Mixto" },
];

const opcionesAfiliacion = [
  { value: "Afiliado", label: "Afiliado" },

  { value: "No Afiliado", label: "No Afiliado" },
];

// ✅ NUEVO: Opciones de regional
const opcionesRegional = [
  {
    value: "ANTIOQUIA",
    label: "ANTIOQUIA",
  },
  { value: "CARIBE", label: "CARIBE" },
  { value: "CENTRO", label: "CENTRO" },
  { value: "ORIENTE", label: "ORIENTE" },
  { value: "SUROCCIDENTE", label: "SUROCCIDENTE" },
];

export default function CrearAfiliado() {
  const { crearAfiliado } = useRues();
  const navigate = useNavigate();

  const [categorias, setCategorias] = useState([]);
  const [opcionesEmpresa, setOpcionesEmpresa] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const obtenerDatos = async () => {
      try {
        // 🔹 CATEGORÍAS
        const resCategorias = await axios.get(
          "https://ruesicn.azurewebsites.net/api/ObtenerCategoria",
        );

        const categoriasMap = resCategorias.data.map((item) => ({
          value: item.categoria,
          label: item.categoria,
        }));

        setCategorias(categoriasMap);

        // 🔹 TAMAÑO EMPRESA
        const resTamano = await axios.get(
          "https://ruesicn.azurewebsites.net/api/ObtenerTamanoEmpresa",
        );

        const tamanoMap = resTamano.data.map((item) => ({
          value: item.tipoEmpresa, // 🔥 si backend espera texto
          label: item.tipoEmpresa,
        }));

        setOpcionesEmpresa(tamanoMap);
      } catch (err) {
        console.error("Error cargando datos", err);
        error("Error cargando datos iniciales");
      }
    };

    obtenerDatos();
  }, []);

  const onSubmit = async (data) => {
    try {
      const payload = {
        ...data,
        categoria_para_facturar: data.categoria_para_facturar?.value,
        desc_tamano_empresa: data.desc_tamano_empresa?.value,
        tipo_de_sector: data.tipo_de_sector?.value,
        tipo_de_afiliacion: data.tipo_de_afiliacion?.value,
        regional: data.regional?.value,
      };

      const response = await crearAfiliado(payload);

      console.log("Respuesta API:", response);
      console.log("Data:", response.data);

      success("Afiliado creado correctamente");
      navigate("/");
    } catch (err) {
      console.error("Error API:", err);

      // 🔥 Validación específica de axios
      if (err.response) {
        const status = err.response.status;

        if (status === 409) {
          // conflicto (ej: ya existe)
          error(err.response.data?.message || "El afiliado ya existe");
          return;
        }

        if (status === 400) {
          error(err.response.data?.message || "Datos inválidos");
          return;
        }

        if (status === 500) {
          error("Error interno del servidor");
          return;
        }
      }

      // 🔥 fallback general
      error("Error al crear afiliado");
    }
  };
  return (
    <div className="container">
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/")}
          variant="outlined"
        >
          Volver al menú principal
        </Button>
      </Box>

      <h2>➕ Crear Afiliado</h2>

      <form onSubmit={handleSubmit(onSubmit)} className="grid">
        {/* ✅ NIT VALIDADO */}
        <div className="field">
          <input
            required
            placeholder="NIT * (Ej: 12345-1)"
            {...register("numero_identificacion", {
              required: "Requerido",
              pattern: {
                value: /^[0-9]+-[0-9]{1}$/,
                message: "Formato inválido. Ej: 12345-1",
              },
            })}
            className={errors.numero_identificacion ? "error" : ""}
          />
          <span>{errors.numero_identificacion?.message}</span>
        </div>

        <div className="field">
          <input type="date" {...register("fecha_afiliacion")} />
        </div>

        <div className="field">
          <input
            required
            placeholder="Razón Social *"
            {...register("razon_social", { required: "Requerido" })}
          />
        </div>

        {/* ✅ REGIONAL COMO SELECT */}
        <div className="field">
          <Controller
            control={control}
            name="regional"
            render={({ field }) => (
              <Select
                {...field}
                options={opcionesRegional}
                placeholder="Regional "
                className="select"
                classNamePrefix="select"
                menuPortalTarget={document.body}
              />
            )}
          />
          <span>{errors.regional?.message}</span>
        </div>

        <div className="field">
          <input placeholder="Municipio" {...register("municipio")} />
        </div>

        <div className="field">
          <input placeholder="Departamento" {...register("departamento")} />
        </div>

        <div className="field">
          <input placeholder="Teléfono " {...register("telefono")} />
        </div>

        <div className="field">
          <input
            placeholder="Actividad Económica "
            {...register("actividad_economica")}
          />
        </div>

        <div className="field">
          <Controller
            control={control}
            name="tipo_de_sector"
            render={({ field }) => (
              <Select
                {...field}
                options={opcionesSector}
                placeholder="Sector"
                className="select"
                classNamePrefix="select"
                menuPortalTarget={document.body}
              />
            )}
          />
        </div>

        <div className="field">
          <Controller
            control={control}
            name="tipo_de_afiliacion"
            render={({ field }) => (
              <Select
                {...field}
                options={opcionesAfiliacion}
                placeholder="Tipo afiliación"
                className="select"
                classNamePrefix="select"
                menuPortalTarget={document.body}
              />
            )}
          />
        </div>

        <div className="field">
          <Controller
            control={control}
            name="categoria_para_facturar"
            rules={{ required: "Requerido" }}
            render={({ field }) => (
              <Select
                {...field}
                options={categorias}
                isLoading={!categorias.length}
                placeholder="Categoria para facturar *"
                className="select"
                classNamePrefix="select"
                menuPortalTarget={document.body}
              />
            )}
          />
        </div>

        <div className="field">
          <Controller
            control={control}
            name="desc_tamano_empresa"
            render={({ field }) => (
              <Select
                {...field}
                options={opcionesEmpresa}
                placeholder="Tamaño Empresa"
                className="select"
                classNamePrefix="select"
                menuPortalTarget={document.body}
              />
            )}
          />
        </div>

        <div className="field">
          <input
            placeholder="Dirección Comercial"
            {...register("direccion_comercial")}
          />
        </div>

        <div className="field">
          <input placeholder="Representante Legal" {...register("rep_legal")} />
        </div>

        <div className="field">
          <input
            placeholder="Correo Representante"
            {...register("correo_rep_legal")}
          />
        </div>

        <div className="field">
          <input
            placeholder="Encargado Calidad"
            {...register("encargado_calidad")}
          />
        </div>

        <div className="field">
          <input placeholder="Correo Calidad" {...register("correo_calidad")} />
        </div>

        <button type="submit">💾 Guardar</button>
      </form>

      <style>{`
        .container {
          max-width: 1100px;
          margin: auto;
          padding: 30px;
        }

        .grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 20px;
        }

        .field {
          display: flex;
          flex-direction: column;
          width: 100%;
        }

        input {
          width: 100%;
          padding: 12px;
          border-radius: 8px;
          border: 1px solid #ccc;
          height: 48px;
          box-sizing: border-box;
        }

        input:focus {
          border-color: #1976d2;
          outline: none;
        }

        .error {
          border: 1px solid red;
        }

        span {
          font-size: 12px;
          color: red;
        }

        .select__control {
          min-height: 48px !important;
          border-radius: 8px !important;
        }

        .select__menu {
          z-index: 9999 !important;
        }

        .select__menu-portal {
          z-index: 9999 !important;
        }

        button {
          grid-column: 1 / -1;
          padding: 14px;
          background: #1976d2;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          cursor: pointer;
        }

        button:hover {
          background: #125ea2;
        }
      `}</style>
    </div>
  );
}
